import {
    IWebsiteScorecardConfig, IWebsiteScorecardCategoryConfig } from '../../../../_shared/models/models-index';
import * as constants from '../../../../_shared/constants/constants';

export class WebsiteScorecardConfig implements IWebsiteScorecardConfig {

  public metricDisplayModes = [
    { name: 'POP', value: 'MOM' },
    { name: 'YOY', value: 'YOY' }
  ];
  public previousDateColumnDisplayOverrides = {
    previousMonthDisplay: 'Prev. Period',
    previousMTDDisplay: 'Prev. Period',
    momDisplay: 'POP'
  }

    public reportTitle = 'Website Scorecard';
    public scorecards: IWebsiteScorecardCategoryConfig[] = [
        {
            category: 'Volume',
            billboards: [
                {
                    title: 'Visits',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-users fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'totalVisits',
                    metricMOMPropertyName: 'totalVisitsMOM',
                    metricYOYPropertyName: 'totalVisitsYOY',
                    metricPreviousMonthPropertyName: 'totalVisitsPreviousMonth',
                    metricPreviousMTDPropertyName: 'totalVisitsPreviousMTD',
                    metricPreviousYearPropertyName: 'totalVisitsPreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'totalVisitsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardTotalVisitsHelp',
                    helpTextTitle: 'Visits',
                    scoreCardCategory: 'Volume'
                },
                {
                    title: 'Unique Visitors',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-user fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'uniqueVisits',
                    metricMOMPropertyName: 'uniqueVisitsMOM',
                    metricYOYPropertyName: 'uniqueVisitsYOY',
                    metricPreviousMonthPropertyName: 'uniqueVisitsPreviousMonth',
                    metricPreviousMTDPropertyName: 'uniqueVisitsPreviousMTD',
                    metricPreviousYearPropertyName: 'uniqueVisitsPreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'uniqueVisitsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardUniqueVisitsHelp',
                    helpTextTitle: 'Unique Visits',
                    scoreCardCategory: 'Volume'
                },
                {
                    title: 'Page Views',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-file fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'pageViews',
                    metricMOMPropertyName: 'pageViewsMOM',
                    metricYOYPropertyName: 'pageViewsYOY',
                    metricPreviousMonthPropertyName: 'pageViewsPreviousMonth',
                    metricPreviousMTDPropertyName: 'pageViewsPreviousMTD',
                    metricPreviousYearPropertyName: 'pageViewsPreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'pageViewsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardPageViewsHelp',
                    helpTextTitle: 'Page Views',
                    scoreCardCategory: 'Volume'
                }
            ],
        },
        {
            category: 'Engagements',
            billboards: [
                {
                    title: 'Time On Site',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.minutesTimeStringFromSeconds,
                    iconClass: 'fa-clock-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'averageTimeOnSite',
                    metricMOMPropertyName: 'averageTimeOnSiteMOM',
                    metricYOYPropertyName: 'averageTimeOnSiteYOY',
                    metricPreviousMonthPropertyName: 'averageTimeOnSitePreviousMonth',
                    metricPreviousMTDPropertyName: 'avreageTimeOnSitePreviousMTD',
                    metricPreviousYearPropertyName: 'avreageTimeOnSitePreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'averageTimeOnSiteMOM',
                    metricFormatKey: constants.formatKeys.minutesTimeStringFromSeconds,
                    helpTextKey: 'WebsiteScorecardTimeOnSiteHelp',
                    helpTextTitle: 'Time on Site',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'VDP Views',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-file fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'totalInventoryDetailViews',
                    metricMOMPropertyName: 'totalInventoryDetailViewsMOM',
                    metricYOYPropertyName: 'totalInventoryDetailViewsYOY',
                    metricPreviousMonthPropertyName: 'totalInventoryDetailViewsPreviousMonth',
                    metricPreviousMTDPropertyName: 'totalInventoryDetailViewsPreviousMTD',
                    metricPreviousYearPropertyName: 'totalInventoryDetailViewsPreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'totalInventoryDetailViewsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardVDPViewsHelp',
                    helpTextTitle: 'VDP Views',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'Engagement Rate',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    iconClass: 'fa-user-plus fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'engagementRate',
                    metricMOMPropertyName: 'engagementRateMOM',
                    metricYOYPropertyName: 'engagementRateYOY',
                    metricPreviousMonthPropertyName: 'engagementRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'engagementRatePreviousMTD',
                    metricPreviousYearPropertyName: 'engagementRatePreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'engagementRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardEngagementRateHelp',
                    helpTextTitle: 'Engagement Rate',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'Bounce Rate',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    iconClass: 'fa-user-plus fa-primary',
                    reverseMetric: true,
                    metricCurrentPropertyName: 'bounceRate',
                    metricMOMPropertyName: 'bounceRateMOM',
                    metricYOYPropertyName: 'bounceRateYOY',
                    metricPreviousMonthPropertyName: 'bounceRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'bounceRatePreviousMTD',
                    metricPreviousYearPropertyName: 'bounceRatePreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'bounceRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardBounceRateHelp',
                    helpTextTitle: 'Bounce Rate',
                    scoreCardCategory: 'Engagements'
                },
            ]
        },
        {
            category: 'Actions',
            billboards: [
                {
                    title: 'Action Rate',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'actionRatePreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    iconClass: 'fa-files-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'actionRate',
                    metricMOMPropertyName: 'actionRateMOM',
                    metricYOYPropertyName: 'actionRateYOY',
                    metricPreviousMonthPropertyName: 'actionRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'actionRatePreviousMTD',
                    metricPreviousYearPropertyName: 'actionRatePreviousYear',
                    // secondaryMetricPropertyName: 'dealerAvgActionRate',
                    // secondaryMetricLabel: 'Dealer Avg',
                    // secondaryMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'actionRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardActionRateHelp',
                    helpTextTitle: 'Action Rate',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Form Submissions',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-file-text fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'formSubmissions',
                    metricMOMPropertyName: 'formSubmissionsMOM',
                    metricYOYPropertyName: 'formSubmissionsYOY',
                    metricPreviousMonthPropertyName: 'formSubmissionsPreviousMonth',
                    metricPreviousMTDPropertyName: 'formSubmissionsPreviousMTD',
                    metricPreviousYearPropertyName: 'formSubmissionsPreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'formSubmissionsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardFormSubmissionsHelp',
                    helpTextTitle: 'Form Submissions',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Phone Calls',
                    subtitle: '',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-phone fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'phoneCalls',
                    metricMOMPropertyName: 'phoneCallsMOM',
                    metricYOYPropertyName: 'phoneCallsYOY',
                    metricPreviousMonthPropertyName: 'phoneCallsPreviousMonth',
                    metricPreviousMTDPropertyName: 'phoneCallsPreviousMTD',
                    metricPreviousYearPropertyName: 'phoneCallsPreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'phoneCallsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardPhoneCallsHelp',
                    helpTextTitle: 'Phone Calls',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Click to Calls',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'clickToCallsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-phone fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'clickToCalls',
                    metricMOMPropertyName: 'clickToCallsMOM',
                    metricYOYPropertyName: 'clickToCallsYOY',
                    metricPreviousMonthPropertyName: 'clickToCallsPreviousMonth',
                    metricPreviousMTDPropertyName: 'clickToCallsPreviousMTD',
                    metricPreviousYearPropertyName: 'clickToCallsPreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'clickToCallsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardClickToCallsHelp',
                    helpTextTitle: 'Click to Calls',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Call Tracking Volume',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'phoneCallsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-phone fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'phoneCalls',
                    metricMOMPropertyName: 'phoneCallsMOM',
                    metricYOYPropertyName: 'phoneCallsYOY',
                    metricPreviousMonthPropertyName: 'phoneCallsPreviousMonth',
                    metricPreviousMTDPropertyName: 'phoneCallsPreviousMTD',
                    metricPreviousYearPropertyName: 'phoneCallsPreviousYear',
                    footerLeftLabel: 'POP',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'phoneCallsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardPhoneCallsHelp',
                    helpTextTitle: 'Call Tracking Volume',
                    scoreCardCategory: 'Actions'
                }
            ]
        }
    ];
}
